export const liveMatches = [
  {
    id: 'm1',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeLogo: 'https://readdy.ai/api/search-image?query=Real%20Madrid%20football%20club%20crest%20logo%20on%20white%20background%2C%20clean%20minimal%20design%2C%20royal%20crown%20emblem&width=120&height=120&seq=match-logo-01&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=FC%20Barcelona%20football%20club%20crest%20logo%20on%20white%20background%2C%20clean%20minimal%20design%2C%20colorful%20emblem&width=120&height=120&seq=match-logo-02&orientation=squarish',
    league: '西甲',
    leagueIcon: 'ri-trophy-line',
    score: '2 : 1',
    status: 'live',
    minute: '78\'',
    homeOdds: 1.85,
    drawOdds: 3.40,
    awayOdds: 4.20,
    viewers: 1285000,
  },
  {
    id: 'm2',
    homeTeam: '曼彻斯特城',
    awayTeam: '利物浦',
    homeLogo: 'https://readdy.ai/api/search-image?query=Manchester%20City%20football%20club%20crest%20logo%20on%20white%20background%2C%20clean%20minimal%20design%2C%20blue%20and%20white%20emblem&width=120&height=120&seq=match-logo-03&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Liverpool%20FC%20football%20club%20crest%20logo%20on%20white%20background%2C%20clean%20minimal%20design%2C%20red%20liver%20bird%20emblem&width=120&height=120&seq=match-logo-04&orientation=squarish',
    league: '英超',
    leagueIcon: 'ri-trophy-line',
    score: '1 : 1',
    status: 'live',
    minute: '63\'',
    homeOdds: 2.10,
    drawOdds: 3.20,
    awayOdds: 3.50,
    viewers: 1560000,
  },
  {
    id: 'm3',
    homeTeam: '洛杉矶湖人',
    awayTeam: '金州勇士',
    homeLogo: 'https://readdy.ai/api/search-image?query=LA%20Lakers%20basketball%20team%20logo%20on%20white%20background%2C%20clean%20minimal%20design%2C%20purple%20and%20gold%20emblem&width=120&height=120&seq=match-logo-05&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Golden%20State%20Warriors%20basketball%20team%20logo%20on%20white%20background%2C%20clean%20minimal%20design%2C%20blue%20and%20gold%20emblem&width=120&height=120&seq=match-logo-06&orientation=squarish',
    league: 'NBA',
    leagueIcon: 'ri-basketball-line',
    score: '98 : 102',
    status: 'live',
    minute: 'Q4 5:32',
    homeOdds: 1.95,
    drawOdds: 0,
    awayOdds: 1.85,
    viewers: 980000,
  },
  {
    id: 'm4',
    homeTeam: '德约科维奇',
    awayTeam: '阿尔卡拉斯',
    homeLogo: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20player%20portrait%20illustration%20on%20white%20background%2C%20clean%20minimal%20design%2C%20sporty%20style&width=120&height=120&seq=match-logo-07&orientation=squarish',
    awayLogo: 'https://readdy.ai/api/search-image?query=Young%20tennis%20player%20portrait%20illustration%20on%20white%20background%2C%20clean%20minimal%20design%2C%20dynamic%20style&width=120&height=120&seq=match-logo-08&orientation=squarish',
    league: '温网决赛',
    leagueIcon: 'ri-base-station-line',
    score: '6 : 4',
    status: 'live',
    minute: 'Set 2',
    homeOdds: 1.72,
    drawOdds: 0,
    awayOdds: 2.10,
    viewers: 720000,
  },
];

export const upcomingMatches = [
  {
    id: 'u1',
    homeTeam: '巴黎圣日耳曼',
    awayTeam: '拜仁慕尼黑',
    league: '欧冠',
    startTime: '2026-08-11 03:00',
    homeOdds: 2.30,
    drawOdds: 3.50,
    awayOdds: 2.80,
  },
  {
    id: 'u2',
    homeTeam: '凯尔特人',
    awayTeam: '雄鹿',
    league: 'NBA',
    startTime: '2026-08-11 08:30',
    homeOdds: 1.90,
    drawOdds: 0,
    awayOdds: 1.90,
  },
  {
    id: 'u3',
    homeTeam: '国际米兰',
    awayTeam: 'AC米兰',
    league: '意甲',
    startTime: '2026-08-11 02:45',
    homeOdds: 2.05,
    drawOdds: 3.10,
    awayOdds: 3.60,
  },
  {
    id: 'u4',
    homeTeam: 'T1战队',
    awayTeam: 'GEN战队',
    league: 'LCK',
    startTime: '2026-08-11 16:00',
    homeOdds: 1.75,
    drawOdds: 0,
    awayOdds: 2.05,
  },
];

export const hotBettings = [
  {
    id: 'b1',
    title: '英超冠军预测',
    description: '2026-2027赛季英超冠军归属',
    options: [
      { label: '曼城', odds: 2.10 },
      { label: '利物浦', odds: 3.50 },
      { label: '阿森纳', odds: 5.00 },
      { label: '其他', odds: 8.00 },
    ],
    deadline: '2026-08-15',
    hotTag: '火热',
  },
  {
    id: 'b2',
    title: '西甲金靴奖',
    description: '2026-2027赛季西甲最佳射手',
    options: [
      { label: '姆巴佩', odds: 2.50 },
      { label: '维尼修斯', odds: 3.80 },
      { label: '莱万', odds: 4.50 },
      { label: '其他', odds: 6.00 },
    ],
    deadline: '2026-08-20',
    hotTag: '推荐',
  },
  {
    id: 'b3',
    title: 'NBA总冠军',
    description: '2026-2027赛季NBA总冠军',
    options: [
      { label: '凯尔特人', odds: 3.00 },
      { label: '掘金', odds: 4.00 },
      { label: '湖人', odds: 6.00 },
      { label: '其他', odds: 7.50 },
    ],
    deadline: '2026-10-01',
    hotTag: '热门',
  },
];

export const latestNews = [
  {
    id: 'n1',
    title: '皇马逆转巴萨，姆巴佩梅开二度助球队登顶西甲榜首',
    summary: '在备受瞩目的西班牙国家德比中，皇家马德里凭借姆巴佩的精彩表现，以3比2逆转战胜巴塞罗那，成功登顶西甲积分榜。',
    category: '足球',
    image: 'https://readdy.ai/api/search-image?query=Professional%20football%20match%20action%20scene%20with%20players%20celebrating%20goal%20on%20stadium%20pitch%2C%20dramatic%20lighting%2C%20sports%20photography%20style%2C%20dynamic%20movement%2C%20white%20and%20green%20kit%2C%20clean%20background%20with%20blurred%20crowd&width=800&height=500&seq=news-01&orientation=landscape',
    date: '2026-08-09',
    views: 156000,
  },
  {
    id: 'n2',
    title: 'NBA夏季联赛：湖人新秀表现出色，率队取得三连胜',
    summary: '洛杉矶湖人在NBA夏季联赛中表现抢眼，新秀前锋在对阵勇士的比赛中砍下28分12篮板，帮助球队取得三连胜。',
    category: '篮球',
    image: 'https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20action%20scene%20with%20player%20dunking%20on%20court%2C%20dramatic%20arena%20lighting%2C%20sports%20photography%20style%2C%20dynamic%20movement%2C%20purple%20and%20gold%20uniform&width=800&height=500&seq=news-02&orientation=landscape',
    date: '2026-08-08',
    views: 123000,
  },
  {
    id: 'n3',
    title: '温网决赛：德约科维奇力克阿尔卡拉斯，斩获第25座大满贯',
    summary: '在温布尔登网球锦标赛男单决赛中，塞尔维亚名将德约科维奇经过五盘大战，最终击败西班牙新星阿尔卡拉斯，职业生涯第25次捧起大满贯奖杯。',
    category: '网球',
    image: 'https://readdy.ai/api/search-image?query=Professional%20tennis%20match%20scene%20with%20player%20serving%20on%20grass%20court%2C%20Wimbledon%20style%2C%20white%20outfit%2C%20dramatic%20lighting%2C%20sports%20photography%2C%20clean%20green%20background&width=800&height=500&seq=news-03&orientation=landscape',
    date: '2026-08-07',
    views: 189000,
  },
  {
    id: 'n4',
    title: 'LCK夏季赛：T1战队3-1击败GEN，成功晋级季后赛决赛',
    summary: '在LCK夏季赛季后赛中，T1战队展现了强大的竞技状态，以3比1的总比分击败卫冕冠军GEN，率先锁定决赛席位。',
    category: '电竞',
    image: 'https://readdy.ai/api/search-image?query=Professional%20esports%20arena%20with%20players%20competing%20on%20stage%2C%20dramatic%20lighting%20with%20LED%20screens%2C%20large%20crowd%2C%20gaming%20tournament%20atmosphere%2C%20dynamic%20and%20colorful&width=800&height=500&seq=news-04&orientation=landscape',
    date: '2026-08-06',
    views: 98000,
  },
];